import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames/bind";
import useModalContext from "common/providers/modal/useModalContext";
import useDisableScroll from "hooks/useDisableScroll/useDisableScroll";

import Panel from "./Panel";
import styles from "./Sidebar.module.scss";

const cx = classNames.bind(styles);

const Sidebar = () => {
    const { useSidebar } = useModalContext();
    const {
        closeSidebar,
        sidebarContent,
        secondSidebarContent,
        goBack,
        closeSecondSidebar,
        isSidebarOpen,
    } = useSidebar();

    useDisableScroll(isSidebarOpen);

    const sidebarElement: HTMLDivElement | null =
        typeof document !== "undefined"
            ? (document.querySelector("#sidebar-root") as HTMLDivElement)
            : null;

    useEffect(() => {
        const handleCloseSidebar = () => {
            closeSidebar();
        };

        const onEscapeHandle = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                closeSidebar();
            }
        };

        document.addEventListener("keydown", onEscapeHandle);
        window.addEventListener("close-sidebar", handleCloseSidebar);

        return () => {
            document.removeEventListener("keydown", onEscapeHandle);
            window.removeEventListener("close-sidebar", handleCloseSidebar);
        };
    }, [closeSidebar]);

    useEffect(() => {
        if (isSidebarOpen && sidebarElement) {
            window?.imichatwidget?.hide?.();
        } else {
            window?.imichatwidget?.show?.();
        }
    }, [isSidebarOpen, sidebarElement]);

    if (isSidebarOpen && sidebarElement) {
        const MainSidebarContent = sidebarContent?.content?.component ?? null;
        const SecondSidebarContent = secondSidebarContent?.content?.component ?? null;

        return (
            <>
                {ReactDOM.createPortal(
                    <>
                        <div
                            className={cx("closeOutsideTargetModal", {
                                secondModalVisible: !!secondSidebarContent,
                            })}
                            onClick={() => closeSidebar()}
                        />
                        <div className={cx("modal")}>
                            {secondSidebarContent && (
                                <Panel
                                    className={cx("secondLayer")}
                                    title={secondSidebarContent?.title ?? ""}
                                    onGoBack={() => {}}
                                    onClose={closeSecondSidebar}
                                    disableScroll={secondSidebarContent.disableScroll}
                                >
                                    <SecondSidebarContent
                                        {...(secondSidebarContent?.content?.props ?? {})}
                                    />
                                </Panel>
                            )}
                            <Panel
                                title={sidebarContent?.title ?? ""}
                                onGoBack={goBack}
                                onClose={() => closeSidebar()}
                                previousModal={sidebarContent?.previousSidebar}
                                footerComponent={sidebarContent?.content?.footerComponent ?? null}
                                disableScroll={sidebarContent?.disableScroll}
                            >
                                <MainSidebarContent {...(sidebarContent?.content?.props ?? {})} />
                            </Panel>
                        </div>
                    </>,
                    sidebarElement
                )}
            </>
        );
    }

    return null;
};

export default Sidebar;
